<template></template>
<script setup lang="ts">
import type {
  AnyLayer,
  BackgroundLayer,
  Map,
  SkyLayer,
  Style,
} from "mapbox-gl";

export type RawLayer = Exclude<Exclude<AnyLayer, BackgroundLayer>, SkyLayer>;

const props = defineProps<{
  layer: RawLayer;
}>();

const mapRef = useMap() as Ref<Map | null>;
function remove(map: Map) {
  if (map.getLayer(props.layer?.id)) {
    map.removeLayer(props.layer.id);
  }
}

watch(
  mapRef,
  (map, oldMap) => {
    if (oldMap) remove(oldMap);
    if (map && props.layer) {
      remove(map);
      map.addLayer(props.layer, "continent-label");
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (mapRef.value) remove(mapRef.value);
});
</script>
